<template>
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="formObj"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
        ref="formRefs"
      >
        <el-form-item label="批次名称" prop="settlementBatchNames">
          <el-select
            multiple
            filterable
            style="width: 300px"
            v-model="formObj.settlementBatchNames"
            placeholder="请选择批次名称"
            clearable
          >
            <el-option
              v-for="(item, index) in queryFormSettlementList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="同步状态" prop="syncStatusDesc">
          <el-select
            style="width: 200px"
            v-model="formObj.syncStatusDesc"
            placeholder="请选择同步状态"
            clearable
          >
            <el-option label="同步完成" value="同步完成"></el-option>
            <el-option label="等待同步" value="等待同步"></el-option>
            <el-option label="同步中" value="同步中"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getPageData(true)"
            >查询</el-button
          >
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="container_table">
        <BaseTable
          :tableData="tableData"
          :columns="columns"
          :showPagination="true"
          :showOperationColumn="false"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
        >
          <template #abnormalCount="{ row }">
            <span 
              :style="row.abnormalCount > 0 ? 'color: #f56c6c; font-weight: bold; cursor: pointer;' : ''"
              @click="row.abnormalCount > 0 ? handleAbnormalClick(row) : null"
            >
              {{ row.abnormalCount }}
            </span>
          </template>
          <template #abnormalRatePercent="{ row }">
            <span 
              :style="row.abnormalRatePercent != null && row.abnormalRatePercent > 0 ? 'color: #f56c6c; font-weight: bold; cursor: pointer;' : ''"
              @click="row.abnormalRatePercent != null && row.abnormalRatePercent > 0 ? handleAbnormalClick(row) : null"
            >
              {{ row.abnormalRatePercent != null ? `${row.abnormalRatePercent}%` : "-" }}
            </span>
          </template>
          <template #syncStatusDesc="{ row }">
            <el-tag
              :type="getStatusType(row.syncStatusDesc)"
              size="small"
            >
              {{ row.syncStatusDesc }}
            </el-tag>
          </template>
          <template #syncStartTime="{ row }">
            {{ formatTime(row.syncStartTime) }}
          </template>
          <template #syncEndTime="{ row }">
            {{ row.syncStatusDesc === '同步中' ? '-' : formatTime(row.syncEndTime) }}
          </template>
          <template #estimatedRemainingTimeSeconds="{ row }">
            {{ formatRemainingTime(row.estimatedRemainingTimeSeconds) }}
          </template>
          <template #remainingCount="{ row }">
            <span v-if="row.remainingCount != null && row.remainingCount > 0" style="color: #909399;">
              {{ row.remainingCount }}
            </span>
            <span v-else-if="row.syncStatusDesc === '同步中'" style="color: #f56c6c;">
              计算异常
            </span>
            <span v-else>-</span>
          </template>
          <template #batchCreateTime="{ row }">
            {{ formatTime(row.batchCreateTime) }}
          </template>
        </BaseTable>
      </div>
    </div>
    <!-- 师傅统计和异常详细弹窗 -->
    <InstallerStatisticsDialog
      :visible.sync="dialogVisible"
      :settlement-batch-name="currentBatchName"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import moment from "moment";
import InstallerStatisticsDialog from "./components/InstallerStatisticsDialog.vue";

export default {
  name: "addSyncRecord",
  components: {
    BaseTable,
    InstallerStatisticsDialog,
  },
  data() {
    return {
      formObj: {
        settlementBatchNames: [],
        syncStatusDesc: "",
      },
      tableData: [],
      total: 0,
      pageSize: 20,
      currentPage: 1,
      columns: [
        {
          prop: "settlementBatchName",
          label: "批次名称",
        },
        {
          prop: "totalCount",
          label: "订单数",
        },
        {
          prop: "abnormalCount",
          label: "异常数",
          slot: "abnormalCount",
        },
        {
          prop: "abnormalRatePercent",
          label: "异常占比",
          slot: "abnormalRatePercent",
        },
        {
          prop: "syncStatusDesc",
          label: "同步状态",
          slot: "syncStatusDesc",
        },
        {
          prop: "batchCreateTime",
          label: "批次创建时间",
          slot: "batchCreateTime",
        },
        {
          prop: "syncStartTime",
          label: "开始时间",
          slot: "syncStartTime",
        },
        {
          prop: "syncEndTime",
          label: "完成时间",
          slot: "syncEndTime",
        },
        {
          prop: "remainingCount",
          label: "剩余数量",
          slot: "remainingCount",
        },
        {
          prop: "estimatedRemainingTimeSeconds",
          label: "剩余时间",
          slot: "estimatedRemainingTimeSeconds",
        },
      ],
      queryFormSettlementList: [],
      dialogVisible: false,
      currentBatchName: "",
      refreshTimer: null, // 自动刷新定时器
    };
  },
  created() {
    this.getPageData(true);
    this.getSettlementList();
    // 启动自动刷新，每15秒刷新一次
    this.startAutoRefresh();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopAutoRefresh();
  },
  methods: {
    getSettlementList() {
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementName",
      }).then((res) => {
        if (res.data.code == 200) {
          this.queryFormSettlementList = res.data.data || [];
        }
      });
    },
    reset() {
      this.$refs.formRefs.resetFields();
      this.getPageData(true);
    },
    onSizeChange(val) {
      this.pageSize = val;
      this.getPageData(false);
    },
    onCurrentChange(val) {
      this.currentPage = val;
      this.getPageData(false);
    },
    getPageData(flag) {
      if (flag) {
        this.pageSize = 20;
        this.currentPage = 1;
      }
      let data = {
        page: this.currentPage,
        size: this.pageSize,
        queryInfoParams: {
          settlementBatchNames: this.formObj.settlementBatchNames,
          syncStatusDesc: this.formObj.syncStatusDesc || null,
        },
      };
      this.axios({
        url: "/pending-settlement-order/add-sync-record/list",
        method: "post",
        data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list || [];
          this.total = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || "查询失败");
        }
      });
    },
    formatTime(time) {
      if (!time) {
        return "-";
      }
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatRemainingTime(seconds) {
      if (seconds == null) {
        return "等待开始";
      }
      if (seconds === 0) {
        return "已完成";
      }
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      if (hours > 0) {
        return `预计还需${hours}小时${minutes}分钟`;
      } else if (minutes > 0) {
        return `预计还需${minutes}分钟${secs}秒`;
      } else {
        return `预计还需${secs}秒`;
      }
    },
    getStatusType(status) {
      switch (status) {
        case "同步完成":
          return "success";
        case "等待同步":
          return "info";
        case "同步中":
          return "warning";
        default:
          return "";
      }
    },
    handleAbnormalClick(row) {
      this.currentBatchName = row.settlementBatchName;
      this.dialogVisible = true;
    },
    /**
     * 启动自动刷新
     */
    startAutoRefresh() {
      // 清除已存在的定时器
      this.stopAutoRefresh();
      // 每15秒刷新一次数据
      this.refreshTimer = setInterval(() => {
        this.getPageData(false);
      }, 10000);
    },
    /**
     * 停止自动刷新
     */
    stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
</style>

